import { errorGetWacUrl } from 'owa-locstrings/lib/strings/errorgetwacurl.locstring.json';
import loc from 'owa-localize';
import getErrorMessageFromWacAttachmentStatus from './getErrorMessageFromWacAttachmentStatus';
import initializeWacUrl from '../actions/initialization/initializeWacUrl';
import WacUrlInfo from '../types/WacUrlInfo';
import { ClientAttachmentId } from 'owa-client-ids';
import WacAttachmentStatus from 'owa-service/lib/contract/WacAttachmentStatus';
import WacAttachmentType from 'owa-service/lib/contract/WacAttachmentType';

export default async function getWacUrlForAttachmentId(
    attachmentId: ClientAttachmentId,
    isEdit: boolean,
    actionSource?: string
): Promise<WacUrlInfo> {
    let wacAttachmentTypeResponse: WacAttachmentType;
    try {
        wacAttachmentTypeResponse = await initializeWacUrl(
            attachmentId,
            isEdit,
            actionSource,
            true /* skipQueue */
        );
    } catch (error) {
        throw {
            errorMessage: loc(errorGetWacUrl),
            error: error,
        };
    }

    if (wacAttachmentTypeResponse.Status === WacAttachmentStatus.Success) {
        return {
            wacUrl: wacAttachmentTypeResponse.WacUrl,
            bootScriptUrl: wacAttachmentTypeResponse.BootScriptUrl,
            wopiSrcUrl: wacAttachmentTypeResponse.WopiSrcUrl,
            accessToken: wacAttachmentTypeResponse.AccessToken,
            accessTokenTtl: wacAttachmentTypeResponse.AccessTokenTtl,
            additionalParameters: wacAttachmentTypeResponse.AdditionalParameters,
            deprecatedTokenAndParameters: wacAttachmentTypeResponse.Token,
        };
    } else {
        const errorMessage = getErrorMessageFromWacAttachmentStatus(
            wacAttachmentTypeResponse.Status
        );
        throw {
            errorMessage: errorMessage,
            error: new Error(
                `GetWacAttachmentInfo failed with status: ${wacAttachmentTypeResponse.Status}`
            ),
        };
    }
}

export interface GetWacUrlForAttachmentIdError {
    errorMessage: string;
    error: Error;
}
